import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ALL, CALL, FULFILLED, GETBOOKINGDATA, REBOOK, REJECTED, RESTARTAGENT, UPDATEBOOKINGDATA } from "src/common/constants";
import { composeThunkAction, convertUTCToLocalTime, getStatusClass } from "src/common/utils";
import {
  audioPlaying,
  callCommentHandler,
  callDetailModal,
  callIdHandler,
  callStatusReasonHandler,
  closeReportModal,
  getAllCallHandler,
  getBookingDetails,
  getCallDetailsByIdHandler,
  reBook,
  restartAgent,
  showReportModalHandler,
  updateBookingDetails,
} from "src/store/slices/callSlice";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar, faDownload, faEye, faMessage, faPhone, faSearch, faDesktop, faUser, faUserTie, faRobot } from "@fortawesome/free-solid-svg-icons";
import { PaginationComponent } from "src/components/Modals/PaginationCom";
import ModalComponent from "src/components/Modals/Modals";
import CallDetailModal from "src/components/Modals/CallDetailModal";
import { RootState } from "src/store/store";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import CallReportModal from "src/components/Modals/CallReportModal";
import { Tooltip } from '@mui/material';
import { signInRememberEmailHandler } from "src/store/slices/authSlice";
import socket from "src/socket/socket";
import axios from "axios";
import { clearAllAudioPlayers, getAllAudioPlayers } from "src/components/UI/AudioManager";

const AdminDashboard = () => {
  const dispatch: ThunkDispatch<object, object, any> = useDispatch();
  const { t } = useTranslation("common");
  const { signInRememberMe, admin } = useSelector((state: RootState) => state.auth)
  const { statusReasonValue } = useSelector((state: RootState) => state.calls)
  const userEmail = admin?.user.email
  const [filterValue, setFilterValue] = useState<string>("");
  const [callData, setCallData] = useState<any>();
  const [selectedCall, setSelectedCall] = useState<any>(null);
  const [totalRecord, setTotalRecord] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [retryCount, setRetryCount] = useState<number>(0);
  const [socketCallId, setSocketCallId] = useState<number>(0);
  const [isDisabled, setIsDisabled] = useState<{ [key: number]: boolean }>({});
  const [showRebookModal, setShowRebookModal] = useState(false);
  const [callToRebook, setCallToRebook] = useState<any>(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editFormData, setEditFormData] = useState<any>({});
  const [makesData, setMakesData] = useState<{ [key: string]: string[] }>({});
  const [selectedMake, setSelectedMake] = useState<string>("");

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: currentYear - 2006 + 1 }, (_, i) => 2006 + i);

  const showCallDetailModal = useSelector(
    (state: RootState) => state.calls.showCallDetailsModal
  );

  const showReportModal = useSelector(
    (state: RootState) => state.calls.showReportModal
  );

  const pageLimit = 10;

  const handlePageChange = (page: number) => {
    if (page === currentPage) {
      return;
    }
    setCurrentPage(page);
  };

  const fetchCallData = async () => {
    try {
      const data: any = {
        pageLimit,
        pageNumber: currentPage,
        searchVal: filterValue,
      };
      const callList: any = await dispatch(getAllCallHandler(data));
      if (callList?.type === `${composeThunkAction(CALL, ALL)}/${FULFILLED}`) {
        const { data, currentPage, totalItems } = callList.payload.data;
        setCallData(data);
        setTotalRecord(totalItems);
        setCurrentPage(currentPage);
        dispatch(callStatusReasonHandler(false))
      } else {
        console.warn("Call data fetching did not succeed.");
      }
    } catch (error: any) {
      console.error("Error fetching call data:", error);
    }
  };

  const handleViewDetails = async (id: any) => {
    try {
      const data = { id };
      const res: any = await dispatch(getCallDetailsByIdHandler(data));
      setSelectedCall(res.payload);
      dispatch(callIdHandler(res.payload?.data?.vonageCallId))
      dispatch(callDetailModal(true));
    } catch (err: any) {
      console.error("Error fetching call details:", err);
    }
  };

  const handleRebook = async (callId: any) => {
    try {
      setIsDisabled((prev: any) => ({ ...prev, [callId]: true }));
      toast.success("Rebooking Process has been started");
      const reBooking = await dispatch(reBook(callId));
      if (reBooking?.type === `${composeThunkAction(CALL, REBOOK)}/${FULFILLED}`) {
        console.log("Re-Booking Succesfully!");

      } else if (reBooking?.type === `${composeThunkAction(CALL, REBOOK)}/${REJECTED}`) {
        console.warn("Failed Re-Booking.");
      } else {
        console.warn("Failed Re-Booking.");
      }
    } catch (err: any) {
      console.error("Error Rebook call details:", err);
    }
  }

  useEffect(() => {
    axios.get(process.env.REACT_APP_APPT_MAKE_MODAL_URL as string)
      .then((res: any) => {
        setMakesData(res.data)
      })
      .catch((err: any) => console.error("Error loading makes/models:", err));
  }, []);

  useEffect(() => {
    socket.on('call-retry-update-res', async (data: any) => {
      setRetryCount(data.retryCount)
      setSocketCallId(data.callId)
      setIsDisabled((prev: any) => ({ ...prev, [data.callId]: false }))
    });

    return (() => {
      socket.off('call-retry-update-res')
    })
  }, [reBook])

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      fetchCallData();
    }, 500);
    dispatch(callDetailModal(false));
    dispatch(closeReportModal());
    if (!signInRememberMe) {
      dispatch(signInRememberEmailHandler(''))
    } else {
      dispatch(signInRememberEmailHandler(userEmail))
    }
    return () => clearTimeout(debounceTimeout);
  }, [filterValue, currentPage]);

  useEffect(() => {
    setCurrentPage(1);
  }, [filterValue]);

  useEffect(() => {
    if (statusReasonValue) {
      fetchCallData();
    }
  }, [statusReasonValue])

  const handleCloseCallDetailModal = () => {
    dispatch(callDetailModal(false));
    dispatch(audioPlaying(false));
    dispatch(callCommentHandler(''));
    setSelectedCall(null);

    const players = getAllAudioPlayers();
    Object.values(players).forEach(player => {
      selectedCall?.data?.channel === 'CALL' && player?.pause?.();
    });
    clearAllAudioPlayers();
  };

  const handleCloseReportModal = () => {
    dispatch(closeReportModal());
  }

  //for future use
  const handleRestartClick = async () => {
    await dispatch(restartAgent()).then((res: any) => {
      if (res?.type === `${composeThunkAction(CALL, RESTARTAGENT)}/${FULFILLED}`) {
        if (res?.payload?.data?.statusCode === 400) {
          toast.error(res?.payload?.data?.message, {
            position: "top-right",
            autoClose: 3000,
          });
        } else {
          toast.success("Agent Restart Succesfully!", {
            position: "top-right",
            autoClose: 3000,
          });
        }
      } else {
        console.warn("Agent not restart.");
      }
    })
  };

  const handleDownloadReport = () => {
    dispatch(showReportModalHandler());
  };

  //Rebook Modal
  const RebookActionModal = () => (
    <ModalComponent
      isOpen={showRebookModal}
      onClose={() => setShowRebookModal(false)}
      modalHeading="Rebook Options"
      size="md"
    >
      <div className="d-flex justify-content-between">
        <button
          className="btn btn-primary"
          onClick={() => {
            setShowRebookModal(false);
            handleEditAndRebookClick(callToRebook.vonageCallId);

          }}
        >
          Edit & Rebook
        </button>
        <button
          className="btn btn-primary"
          onClick={() => {
            handleRebook(callToRebook?.vonageCallId);
            setShowRebookModal(false);
          }}
        >
          Confirm Rebook
        </button>
      </div>
    </ModalComponent>
  );

  //Function to handel Edit and Rebook
  const handleEditAndRebookClick = async (callId: string) => {
    try {
      const res: any = await dispatch(getBookingDetails(callId))
      if (res.type === `${composeThunkAction(CALL, GETBOOKINGDATA)}/${FULFILLED}`) {
        const time_24_formate = res?.payload.data.data.time_slot && convertTo24HourFormat(res?.payload.data.data.time_slot)
        setEditFormData({ ...res?.payload.data.data, time_slot_24h: time_24_formate });
        setShowEditModal(true);
      } else {
        toast.error("Could not fetch booking details.");
      }
    } catch (err) {
      console.error("Error fetching booking data", err);
      toast.error("Something went wrong.");
    }
  };

  //function to convert 24 hour format
  function convertTo24HourFormat(time12h: string): string {
    const normalized = time12h.trim().toLowerCase().replace(/\./g, '');
    const [time, modifier] = normalized.split(' ');
    let [hours, minutes] = time.split(':').map(Number);
    if (modifier === 'p.m.' || modifier === 'pm') {
      if (hours !== 12) hours += 12;
    } else if (modifier === 'a.m.' || modifier === 'am') {
      if (hours === 12) hours = 0;
    }
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  }

  //function to save edited rebook details
  const handleSaveEditedRebook = async () => {
    const requiredFields = [
      "mobile",
      "make_input",
      "year_input",
      "model_input",
      "first_name_input",
      "service_name",
      "preferred_option",
      "date",
      "time_slot",
    ];
    for (let field of requiredFields) {
      if (!editFormData[field]) {
        toast.error(`Field "${field.replace(/_/g, ' ')}" is required.`);
        return;
      }
    }
    try {
      const data = {
        callId: callToRebook.vonageCallId,
        payload: editFormData
      }
      const updateRes = await dispatch(updateBookingDetails(data))
      if (updateRes.type === `${composeThunkAction(CALL, UPDATEBOOKINGDATA)}/${FULFILLED}`) {
        setShowEditModal(false);
        handleRebook(callToRebook.vonageCallId)
      } else {
        toast.error("Updating booking failed.");
      }
    } catch (err) {
      console.error("Error during update & rebook", err);
      toast.error("Something went wrong during update or rebook.");
    }
  };

  //function to convert 12 hour format
  function convertTo12HourFormat(time24: any) {
    const [hours, minutes] = time24.split(':');
    const hourInt = parseInt(hours, 10);
    if (hourInt === 0) {
      return `12:${minutes} a.m.`;
    } else if (hourInt < 12) {
      return `${hourInt}:${minutes} a.m.`;
    } else if (hourInt === 12) {
      return `12:${minutes} p.m.`;
    } else {
      return `${hourInt - 12}:${minutes} p.m.`;
    }
  }

  //Edit Rebook Modal
  const EditRebookFormModal = () => (
    <ModalComponent
      isOpen={showEditModal}
      onClose={() => setShowEditModal(false)}
      modalHeading="Edit Booking Details"
      size="lg"
    >
      <div className="form-group row g-3">
        <div className="col-md-6">
          <label className="form-label">Mobile</label>
          <input
            required
            className="form-control"
            value={editFormData && editFormData.mobile || ""}
            onChange={(e) =>
              setEditFormData((prev: any) => ({
                ...prev,
                mobile: e.target.value,
              }))
            }
          />
        </div>
        <div className="col-md-6">
          <label className="form-label">First Name</label>
          <input
            required
            className="form-control"
            value={editFormData && editFormData.first_name_input || ""}
            onChange={(e) =>
              setEditFormData((prev: any) => ({
                ...prev,
                first_name_input: e.target.value,
              }))
            }
          />
        </div>
        <div className="col-md-6">
          <label className="form-label">Last Name</label>
          <input
            className="form-control"
            value={editFormData && editFormData.last_name_input || ""}
            onChange={(e) =>
              setEditFormData((prev: any) => ({
                ...prev,
                last_name_input: e.target.value,
              }))
            }
          />
        </div>
        <div className="col-md-6">
          <label className="form-label">Make</label>
          <select
            required
            className="form-control"
            value={editFormData?.make_input || ""}
            onChange={(e) => {
              const selectedMake = e.target.value;
              setEditFormData((prev: any) => ({
                ...prev,
                make_input: selectedMake,
                model_input: "", // reset model when make changes
              }));
            }}
          >
            <option value="">Select Make</option>
            {Object.keys(makesData).map((make) => (
              <option key={make} value={make}>{make}</option>
            ))}
          </select>
        </div>

        <div className="col-md-6">
          <label className="form-label">Model</label>
          <select
            required
            className="form-control"
            value={editFormData?.model_input || ""}
            onChange={(e) =>
              setEditFormData((prev: any) => ({
                ...prev,
                model_input: e.target.value,
              }))
            }
            disabled={!editFormData?.make_input}
          >
            <option value="">Select Model</option>
            {editFormData?.make_input &&
              makesData[editFormData.make_input]?.map((model: string) => (
                <option key={model} value={model}>{model}</option>
              ))}
          </select>
        </div>

        <div className="col-md-6">
          <label className="form-label">Year</label>
          <select
            className="form-control"
            value={editFormData?.year_input || ""}
            onChange={(e) =>
              setEditFormData((prev: any) => ({
                ...prev,
                year_input: e.target.value,
              }))
            }
          >
            <option value="">Select Year</option>
            {years.map((year) => (
              <option key={year} value={year}>{year}</option>
            ))}
          </select>
        </div>
        <div className="col-md-6">
          <label className="form-label">Service Name</label>
          <input
            required
            className="form-control"
            value={editFormData && editFormData.service_name || ""}
            onChange={(e) =>
              setEditFormData((prev: any) => ({
                ...prev,
                service_name: e.target.value,
              }))
            }
          />
        </div>
        <div className="col-md-6">
          <label className="form-label">Preferred Option</label>
          <select
            required
            className="form-control"
            value={editFormData && editFormData.preferred_option || ""}
            onChange={(e) =>
              setEditFormData((prev: any) => ({
                ...prev,
                preferred_option: e.target.value,
              }))
            }
          >
            <option value="">Select</option>
            <option value="Drop off">Drop off</option>
            <option value="Wait">Wait</option>
          </select>
        </div>
        <div className="col-md-6">
          <label className="form-label">Date</label>
          <input
            required
            type="date"
            className="form-control"
            value={editFormData && editFormData.date || ""}
            onChange={(e) =>
              setEditFormData((prev: any) => ({
                ...prev,
                date: e.target.value,
              }))
            }
          />
        </div>
        <div className="col-md-6">
          <label className="form-label">Time Slot</label>
          <input
            required
            type="time"
            className="form-control"
            value={editFormData?.time_slot_24h || ""}
            onChange={(e) => {
              const timeString = e.target.value;
              setEditFormData((prev: any) => ({
                ...prev,
                time_slot_24h: timeString,
                time_slot: timeString ? convertTo12HourFormat(timeString) : '',
              }));
            }}
          />
        </div>
      </div>
      <div className="mt-4 d-flex justify-content-end">
        <button className="btn btn-primary" onClick={handleSaveEditedRebook}
        >
          Save & Rebook
        </button>
      </div>
    </ModalComponent>
  );

  return (
    <>
      <div>
        <div className="row">
          <div className="col">
            <div className="d-flex mb-2 align-items-center justify-content-between gap-2">
              {/* for future use  */}
              {/*  <button
                    type="button"
                    className="btn btn-primary d-flex align-items-center justify-content-between"
                    onClick={handleRestartClick}
                  >
                    <span className="text-nowrap">Restart Agent &nbsp;</span>
                    <FontAwesomeIcon icon={faPowerOff} />
                  </button> */}
              <div className="input-group w-auto">
                <div className="form-outline">
                  <input
                    type="search"
                    id="form1"
                    className="form-control"
                    placeholder="Search"
                    value={filterValue}
                    onChange={(e) => setFilterValue(e.target.value)}
                  />
                </div>
                <button
                  type="button"
                  className="btn btn-primary d-flex align-items-center justify-content-between search-btn"
                >
                  <FontAwesomeIcon icon={faSearch} />
                </button>
              </div>
              <button
                type="button"
                className="btn btn-primary d-flex align-items-center justify-content-between"
                onClick={handleDownloadReport}
              >
                <span className="text-nowrap">Download Report &nbsp;</span>
                <FontAwesomeIcon icon={faDownload} />
              </button>

            </div>
            <div className="table-responsive">
              <table className="table cs-table table-striped">
                <thead className="table-head">
                  <tr>
                    <th className="d-none">{t("common.callId")}</th>
                    <th>{t("common.bookingId")}</th>
                    <th>{t("common.vendorBookingId")}</th>
                    <th>{t("common.from")}</th>
                    <th>{t("common.duration")}</th>
                    <th>{t("common.callArrivedAt")}</th>
                    <th>{t("common.status")}</th>
                    <th>{t("common.channel")}</th>
                    <th>{t("common.disconnectedBy")}</th>
                    <th>{t("common.statusReason")}</th>
                    <th className="wd-130 text-center">{t("common.actions")}</th>
                  </tr>
                </thead>
                <tbody>
                  {callData?.map((item: any, index: any) => (
                    <tr key={index}>
                      <td className="d-none">{item.vonageCallId}</td>
                      <td className="text-nowrap">{item.bookingId || "N/A"}</td>
                      <td>{item.vendorBookingId || "N/A"}</td>
                      <td>
                        {item.from
                          ? ['withheld', 'anonymous'].includes(item.from.replace(/^\+/, '').toLowerCase())
                            ? item.from.replace(/^\+/, '').toLowerCase()
                            : `+${item.from.replace(/^\+/, '')}`
                          : '-'}
                      </td>
                      <td className="text-nowrap">{item.channel !== 'FORM' ? item.duration : "N/A"}</td>
                      <td className="text-nowrap">{convertUTCToLocalTime(item.createdAt)}</td>
                      <td>
                        {item.reason ? (
                          <Tooltip title={item.reason} placement="top">
                            <span className={`status-tooltip  ${getStatusClass(item.status)}`}>{item.status}</span>
                          </Tooltip>
                        ) : (
                          <span className={` ${getStatusClass(item.status)}`}>{item.status}</span>
                        )}
                      </td>
                      <td>{item.channel === 'CALL' && <FontAwesomeIcon icon={faPhone} className="fs-6 cs-color" />}
                        {item.channel === 'FORM' && <FontAwesomeIcon icon={faDesktop} className="fs-6 cs-color" />}
                        {item.channel === 'CHAT' && <FontAwesomeIcon icon={faMessage} className="fs-6 cs-color" />}</td>
                      <td>
                        {
                          (item.disconnectedBy && item.channel === 'CALL') ? (
                            <FontAwesomeIcon icon={
                              item.disconnectedBy === 'user' ? faUser :
                                item.status === 'TRANSFERRED' ? faUserTie :
                                  faRobot
                            } 
                            title={
                              item.disconnectedBy === 'user' ? 'Customer' :
                                item.status === 'TRANSFERRED' ? 'Representative' :
                                  'Agent'
                            } className="fs-6 cs-color" />
                          ) : (
                            <span>{'N/A'}</span>
                          )
                        }
                      </td>
                      <td>
                        {item.statusReason ? (
                          <span>{item.statusReason}</span>
                        ) : (
                          <span>{'N/A'}</span>
                        )}
                      </td>
                      <td align='center'>
                        <span className="d-flex align-item-center gap-4 justify-content-center">
                          <button
                            className="btn p-0"
                            onClick={() => handleViewDetails(item.vonageCallId)}
                          >
                            <FontAwesomeIcon
                              icon={faEye}
                              className="fs-6 cs-color"
                            />
                          </button>
                          {item.status !== 'BOOKED' ? <Tooltip title={`Retry Count: ${socketCallId === item.vonageCallId
                            ? retryCount ?? 0
                            : item.retryCount ?? 0
                            }`} placement="top">
                            <button
                              className="btn p-0"
                              onClick={() => {
                                setCallToRebook(item);
                                setShowRebookModal(true);
                              }}
                              disabled={isDisabled[item.vonageCallId]}
                            >
                              <FontAwesomeIcon
                                icon={faCalendar}
                                className="fs-6 cs-color"
                              />
                            </button>
                          </Tooltip> : <button
                            className="btn p-0"
                            disabled
                          >
                            <FontAwesomeIcon
                              icon={faCalendar}
                              className="fs-6 cs-color"
                            />
                          </button>}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          {/* Responsive Pagination Wrapper */}
          <div className="pagination-responsive-wrapper">
            <PaginationComponent
              currentPage={currentPage}
              onPageChange={handlePageChange}
              pageSize={pageLimit}
              siblingCount={1}
              totalCount={totalRecord}
            />
          </div>
        </div>
      </div>
      <ModalComponent
        isOpen={showCallDetailModal}
        onClose={handleCloseCallDetailModal}
        modalHeading={t("common.callDetails")}
        size="lg"
        callAttachment={selectedCall}
      >
        <CallDetailModal selectedCall={selectedCall} />
      </ModalComponent>
      <ModalComponent
        isOpen={showReportModal}
        onClose={handleCloseReportModal}
        modalHeading={t("common.reportDetails")}
        size="lg"
      >
        <CallReportModal />
      </ModalComponent>
      {RebookActionModal()}
      {EditRebookFormModal()}
    </>
  );
};

export default AdminDashboard;